import type {
  Ability,
  CharacterStats,
  MovementStats,
} from '../../CharacterTypes';

export const ROGUE_CONFIG = {
  name: 'Unseen',
  description: 'Agile ranged attacker specializing in throwing stars and quick movement',
  baseStats: {
    strength: 8,
    dexterity: 18,
    intelligence: 10,
    luck: 10,
    attack: 14,
    magicAttack: 5,
    defense: 7,
    magicDefense: 10,
    criticalRate: 0.20
  } as CharacterStats,
  healthMultiplier: 0.8,
  manaMultiplier: 1.2,
  color: '#4B0082',
  movementStats: {
    jumpPower: 1250,
    targetJumpHeight: 200,
    moveSpeed: 380,
    gravityScale: 0.85,
    terminalVelocity: 1100,
    acceleration: 4500,
    deceleration: 7000
  } as MovementStats,
  abilities: [
    {
      id: 'assassin_auto',
      name: 'Throw Star',
      damage: 8,
      manaCost: 0,
      cooldown: 500,
      lastUsed: 0,
      range: 500,
      castTime: 0,
      description: 'Basic throwing star attack.',
      icon: '/icons/throw_star.svg'
    },
    {
      id: 'throw_star',
      name: 'Throw Star',
      damage: 12,
      manaCost: 0,
      cooldown: 300,
      lastUsed: 0,
      range: 650,
      castTime: 0,
      description: 'Throw a single star at the enemy. Consumes 1 Star.',
      icon: '/icons/throw_star.svg'
    },
    {
      id: 'lucky_seven',
      name: 'Lucky Seven',
      damage: 18,
      manaCost: 10,
      cooldown: 1200,
      lastUsed: 0,
      range: 600,
      castTime: 0,
      description: 'Throw two stars in quick succession. Consumes 2 Stars.',
      icon: '/icons/lucky_seven.svg'
    },
    {
      id: 'haste',
      name: 'Haste',
      damage: 0,
      manaCost: 25,
      cooldown: 60000,
      lastUsed: 0,
      range: 0,
      castTime: 0,
      description: 'Greatly increase movement speed and jump height for 60 seconds.',
      icon: '/icons/haste.svg'
    },
    {
      id: 'blink',
      name: 'Blink',
      damage: 0,
      manaCost: 15,
      cooldown: 2000,
      lastUsed: 0,
      range: 300,
      castTime: 0,
      description: 'Teleport a short distance in the facing direction.',
      icon: '/icons/dev_teleport.svg'
    },
    {
      id: 'dark_sight',
      name: 'Dark Sight',
      damage: 0,
      manaCost: 15,
      cooldown: 20000,
      lastUsed: 0,
      range: 0,
      castTime: 0,
      description: 'Hide in the shadows, becoming invisible to enemies.',
      icon: '/icons/dark_sight.svg'
    }
  ] as Ability[]
};
